import { Container, Sprite } from "@pixi/react";
import React from "react";
import { useSelector } from "react-redux";
import { ASSET_NAME } from "../../../../assets";
import * as PIXI from "pixi.js";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { usePopiToolbarDimensions } from "../../../../Hooks/usePopiToolbarDimensions";
import ButtonPlay from "../Buttons/ButtonPlay";
import ButtonHoldAndWinPlay from "../Buttons/ButtonHoldAndWinPlay";
import ButtonTurbo from "../Buttons/ButtonTurbo";
import ButtonAutoplay from "../Buttons/ButtonAutoplay";
import ButtonMaxBet from "../Buttons/ButtonMaxBet";
import ButtonBetSelect from "../Buttons/ButtonBetSelect";
import BalanceDisplay from "../Displays/BalanceDisplay";
import BetDisplay from "../Displays/BetDisplay";
import WinDisplay from "../Displays/WinDisplay";
import ButtonBonusBuy from "../Buttons/ButtonBonusBuy";
import { selectHoldAndWinActive } from "../../../../State/selectors";
import RespinsDisplay from "../../shared/Displays/RespinsDisplay";

const ToolbarBottom = () => {
  const texture = PIXI.Assets.get(ASSET_NAME.toolbar_gradient);
  const { dimensions } = useDimensions();

  // Get toolbar dimensions
  const toolbar = usePopiToolbarDimensions();

  // Check if HoldAndWin feature is active
  const holdAndWinActive = useSelector(selectHoldAndWinActive);

  return (
    <Container
      name="secondary_toolbar_bottom"
      x={(dimensions.width - toolbar.width) / 2}
      y={dimensions.height - toolbar.height}
    >
      {/* Background */}
      <Sprite height={toolbar.height} texture={texture} width={toolbar.width} />

      <BalanceDisplay toolbar={toolbar} />
      <BetDisplay toolbar={toolbar} />
      <ButtonAutoplay toolbar={toolbar} />
      {holdAndWinActive ? (
        <>
          <RespinsDisplay toolbar={toolbar} />
          <ButtonHoldAndWinPlay toolbar={toolbar} />
        </>
      ) : (
        <>
          <ButtonBonusBuy toolbar={toolbar} />
          <ButtonPlay toolbar={toolbar} />
        </>
      )}
      <ButtonTurbo toolbar={toolbar} />
      <ButtonMaxBet toolbar={toolbar} />
      <ButtonBetSelect toolbar={toolbar} />
      <WinDisplay toolbar={toolbar} />
    </Container>
  );
};

export default ToolbarBottom;
